import { matchApi } from '@/api/index';
import formatDate from '../../lib/formatDate';

const state = {
    noDataMode: false,
    loadingShow: true,
    downloadFooterShow: false,
    currentListData: [], // 当前选中tab下的所有数据
    finalListSplitDateData: {}
};

const getters = {
    getMatchNoDataMode: state => state.noDataMode,
    getMatchLoadingShow: state => state.loadingShow,
    getDownloadFooterShow: state => state.downloadFooterShow,
    getCurrentMatchListData: state => state.currentListData, // 当前选中tab下的所有数据
    getFinalListSplitDateData: state => state.finalListSplitDateData, // 当前选中tab下时间段所有数据
};

const actions = {
    matchListApi ({ commit, state, rootState }, { urlApi, finalDate }) {
        const _url = `${urlApi}?start=${finalDate}` || '';
        state.loadingShow = true;
        return matchApi.getMatchList(_url).then(response => {
            commit('getMatchList', response);
        }, error => {
            console.log('error', error);
        });
    }
};

const mutations = {
    getMatchList (state, params) { // 请求比赛列表
        state.loadingShow = false;
        state.downloadFooterShow = true;
        state.currentListData = []
        state.finalListSplitDateData = {}
        if (params.list.length) {
            state.noDataMode = false;
            state.currentListData = params.list;
            state.currentListData.forEach((elem, index) => {
                let obj = formatDate(elem.start_play);
                elem.localdate = obj;
                if (!state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day]) {
                    state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day] = [];
                }
                state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day][state.finalListSplitDateData[elem.localdate.local_ymd + ' ' + elem.localdate.local_day].length] = elem;
            });
        } else {
            state.noDataMode = true;
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/matchListStore.js